/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmVectorStoresUpdateFile } from "../../funcs/llmVectorStoresUpdateFile.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.UpdateVectorStoreFileAttributesRequest$inboundSchema,
};

export const tool$llmVectorStoresUpdateFile: ToolDefinition<typeof args> = {
  name: "llm-vector-stores-update-file",
  description: `Update file attributes

Updates the metadata attributes attached to a file within a vector store.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmVectorStoresUpdateFile(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
